import Model from '../Model';

export default class QueryResultsPreviewModel extends Model {
	constructor(data) {
		super(data);
		this.files = data.map(file => {
			let splitted = file.sourcePath.split('/');
			return {
				artifact: splitted[splitted.length-1] || '',
				path: file.sourcePath || '',
                targetPath:file.targetPath || '',
				size: file.fileSize || ''
			}
		});
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/QueryResultsPreviewModel.js